import { createSlice } from '@reduxjs/toolkit';

import {
  type ChangeCountryType,
  type ChangeCurrencyType,
  type ChangeLanguageType,
  type IUserState,
} from './types';

const initialState: IUserState = {
  currencyType: undefined,
  languageType: undefined,
  countryType: undefined,
  uuid: undefined,
};

const userSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    changeCurrencyType: (state, action: ChangeCurrencyType): void => {
      state.currencyType = action.payload.currencyType;
    },
    changeLanguageType: (state, action: ChangeLanguageType): void => {
      state.languageType = action.payload.languageType;
    },
    changeCountryType: (state, action: ChangeCountryType): void => {
      state.countryType = action.payload.countryType;
    },
  },
});

export const { changeCurrencyType, changeLanguageType, changeCountryType } =
  userSlice.actions;

export default userSlice.reducer;
